import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { CirclePicker } from 'react-color';

export default class ProductionLine extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            data: null,
            page: 1,
            per_page: 30,
            phrase: '',
            loading: true
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/productionline/get", {
            id: this.state.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save() {
        if (this.isBlank(this.state.data.record.code)) this.state.data.record.code = 0;
        
        this.httpPost("api/v1/productionline/save", {
            id: this.getCurrentFormId(),
            organizationId: this.state.data.global.company.id,
            name: this.state.data.record.name,
            location: this.state.data.record.location,
            color: this.state.data.record.color,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    handleChangeComplete = (color) => {
        this.state.data.record.color = color.hex;
        this.setState({ data: this.state.data });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable">
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات خط تولید" : "افزودن خط تولید جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">عنوان </label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.name} onChange={e => this.state.data.record.name = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="250" />
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <div className="form-group">
                                            <label for="accountnumber" className="title1">موقعیت فیزیکی</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.location} onChange={e => this.state.data.record.location = e.target.value} autocomplete="off" type="text" className="form-control input-smnumber" maxlength="400" />
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label for="name" className="title1">رنگ</label>
                                            <CirclePicker
                                                color={this.state.data.record.color}
                                                onChangeComplete={this.handleChangeComplete}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف </button>
                            <button type="submit" onClick={e=>this.save()} className="btn btn-success">
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}